// USA
export const locale = {
  lang: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
    },
    MENU: {
      NEW: 'new',
      ACTIONS: 'Actions',
      CREATE_POST: 'Create New Post',
      PAGES: 'Pages',
      FEATURES: 'Features',
      APPS: 'Apps',
      DASHBOARD: 'Dashboard',
      PROFILE: 'Profile',
      CUSTOMER_INSIGHTS: 'Customer Insights',
      USER_MANAGEMANET: 'User Management',
      USER_ROLE_MANAGEMANET: 'User Role Management',
      ROLE_PERMISSION_GROUP: 'Role Permission Group',
      MY_SUBSCRIPTIONS: 'My Subscriptions',
      COUPON_MANAGEMANET: 'Coupon Management',
      SELECT_STORE: 'Select Store',
    },
    HEADER_MENU: {
      THEME: {
        LIGHT: 'Light',
        DARK: 'Dark',
        SYSTEM: 'System',
      },
      PROFILE_MENU: {
        LANGUAGE: 'Language',
        SWITCH_TO_USER: 'Switch To User',
        SIGNOUT: 'Sign Out',
        CONFIRM_LOGOUT: 'Are you sure you want to sign out?',
      }
    },
    SIGNIN_MODULE: {
      SIGNIN: 'Sign In',
      EMAIL: 'Email',
      EMAIL_REQUIRED: 'Email is required',
      EMAIL_INVALID: 'Email is invalid',
      EMAIL_ATLEAST3_SYMBOLS: 'Email should have at least 3 symbols',
      EMAIL_MAX_VALIDATION: 'Email should have maximum 360 symbols',
      PHONE: 'Phone',
      PASSWORD: 'Password',
      PASSWORD_REQUIRED: 'Password is required',
      FORGOT_PASSWORD_LINK: 'Forgot Password ?',
    },
    FORGOT_PASSWORD_MODULE: {
      FORGOT_PASSWORD: 'Forgot Password',
      EMAIL: 'Email',
      PHONE: 'Phone',
      EMAIL_REQUIRED: 'Email is required',
      EMAIL_INVALID: 'Email is invalid',
      EMAIL_ATLEAST3_SYMBOLS: 'Email should have at least 3 symbols',
      EMAIL_MAX_VALIDATION: 'Email should have maximum 360 symbols',
      FORGOT_ERROR: 'Sorry, looks like there are some errors detected, please try again.',
      PASSWORD_RESET_LINK_SENT: 'A password reset link has been sent to your email. Please check your inbox.',
    },
    RESET_PASSWORD_MODULE: {
      RESET_PASSWORD: ' Reset Password',
      NEW_PASSWORD: 'New Password',
      NEW_PASSWORD_REQUIRED: 'New Password is required',
      PASSWORD_MUST_6CHAR_LONG: 'Password must be at least 6 characters long',
      PASSWORD_COMPLEXITY_REQUIREMENTS: 'Password should have at least one small alphabet,one capital alphabet,one digit and one special character',
      CONFIRM_PASSWORD: 'Confirm Password',
      CONFIRM_PASSWORD_REQUIRED: 'Confirm Password is required',
      PASSWORD_NOT_MATCH: 'Passwords do not match',
    },
    PLEASE_WAIT: 'Please wait...',
    SAVE_CHANGES: 'Save Changes',
    COUNTINUE: 'Continue',
    BACK: 'Back',
    SUBMIT: 'Submit',
    CANCEL: 'Cancel',
    EDIT: 'Edit',
    VIEW: 'View',
    DELETE: 'Delete',
    PAGES: {
      ROW_PER_PAGE: 'Row Per Page',
      TOTAL_RECORD: 'Total Records',
      NEXT: 'Next',
      PREVIOUS: 'Previous',
    },
    NO_RECORDS: 'No Records Available',
    YES: 'Yes',
    NO: 'No',
    DASHBOARD: {
      SELECT_MONTH: 'Select Month',
      POS_USERS_COUNT: 'POS Users Count',
      TOTAL_NET_PROFIT: 'Total Net Profit',
      TOTAL_TRANSACTIONS: 'Total Transactions',
      GROSS_SALES: 'Gross Sales',
      NET_PROFIT: 'Net Profit',
      TRANSACTIONS: 'Transactions',
      AVERAGE_NET_SALES: 'Average Net Sales',
      CURRENT_VS_PREVIOUS_WEEKS: 'Current vs Previous Weeks',
      PREVIOUS_WEEK: 'Previous Week',
      CURRENT_WEEK: 'Current Week',
      WEEK: 'Week',
      USER_ORDERS: 'User Orders',
      USER_ORDERS_SUBTITLE: 'View all user transactions',
      SEARCH_USERS: 'Search users...',
      USER_ORDERS_TABLE: {
        NAME: 'Name',
        TOTAL_ORDERS: 'Total Orders',
        TOTAL_AMOUNT: 'Total Amount',
      },
    },
    PRODUCT_PERFORMANCE: {
      TITLE: 'Products Performance',
      SUBTITLE: 'View product performance metrics',
      FROM_DATE: 'From:',
      TO_DATE: 'To:',
      FROM_DATE_PLACEHOLDER: 'From Date',
      TO_DATE_PLACEHOLDER: 'To Date',
      SORT_BY: 'Sort By',
      SEARCH_PRODUCT: 'Search Product',
      TABLE: {
        PRODUCT_NAME: 'Product Name',
        BARCODE: 'Barcode',
        SKU: 'SKU',
        NO_OF_ORDERS: 'No of Orders',
      },
      SORT_OPTIONS: {
        SORT_BY: 'Sort By',
        MOST_BOUGHT: 'Most Bought',
        LEAST_BOUGHT: 'Least Bought',
      },
    },
    SALES_BY_HOURS: {
      TITLE: 'Sales by Hours',
      SUBTITLE: 'Number of orders by hour of the day',
      DATE: 'Date',
      DATE_PLACEHOLDER: 'Select Date',
      SERIES_NAME: 'Number of Orders',
      Y_AXIS_TITLE: 'Number of Orders',
      TOOLTIP_SUFFIX: 'orders',
    },
    SALES_VS_STORES: {
      TITLE: 'Sales vs Stores',
      SUBTITLE: 'Number of orders by store',
      FROM_DATE: 'From:',
      TO_DATE: 'To:',
      FROM_DATE_PLACEHOLDER: 'From Date',
      TO_DATE_PLACEHOLDER: 'To Date',
      SERIES_NAME: 'Number of Orders',
      Y_AXIS_TITLE: 'Number of Orders',
      TOOLTIP_SUFFIX: 'orders',
    },
    SALES_VS_CATEGORIES: {
      TITLE: 'Sales vs Categories',
      SUBTITLE: 'Number of orders by category',
      FROM_DATE: 'From:',
      TO_DATE: 'To:',
      FROM_DATE_PLACEHOLDER: 'From Date',
      TO_DATE_PLACEHOLDER: 'To Date',
      SERIES_NAME: 'Number of Orders',
      Y_AXIS_TITLE: 'Number of Orders',
      TOOLTIP_SUFFIX: 'orders',
    },
    SALES_VS_GROUPS: {
      TITLE: 'Sales vs Groups',
      SUBTITLE: 'Number of orders by group',
      FROM_DATE: 'From:',
      TO_DATE: 'To:',
      FROM_DATE_PLACEHOLDER: 'From Date',
      TO_DATE_PLACEHOLDER: 'To Date',
      SERIES_NAME: 'Number of Orders',
      Y_AXIS_TITLE: 'Number of Orders',
      TOOLTIP_SUFFIX: 'orders',
    },
    SALES_VS_DAYS: {
      TITLE: 'Sales vs Days',
      SUBTITLE: 'Number of orders by day of week',
      WEEK: 'Week:',
      WEEK_PLACEHOLDER: 'Select Week',
      SERIES_NAME: 'Number of Orders',
      Y_AXIS_TITLE: 'Number of Orders',
      TOOLTIP_SUFFIX: 'orders',
    },
    VENDOR_PROFILE: {
      PROFILE: 'Profile',
      CHANGE_PASSWORD: 'Change password'
    },
    PROFILE_DETAILS_TAB: {
      PROFILE_DETAILS: 'Profile Details',
      NAME: 'Name',
      EMAIL_OR_PHONE: 'Email',
      PIN: 'Pin',
      PIN_INVALID: 'PIN must be between 4 to 6 digits.',
    },
    CHANGE_PASSWORD_TAB: {
      OLD_PASSWORD: 'Old Password',
      OLD_PASSWORD_REQUIRED: 'Old Password is required',
      NEW_PASSWORD: 'New Password',
      NEW_PASSWORD_REQUIRED: 'New Password is required',
      PASSWORD_MUST_6CHAR_LONG: 'Password must be at least 6 characters long',
      PASSWORD_COMPLEXITY_REQUIREMENTS: 'Password should have at least one small alphabet,one capital alphabet,one digit and one special character',
      CONFIRM_PASSWORD: 'Confirm Password',
      CONFIRM_PASSWORD_REQUIRED: 'Confirm Password is required',
      PASSWORD_NOT_MATCH: 'Passwords do not match',
    },
    USER_MANAGEMENT: {
      SEARCH_USERS: 'Search Users',
      USERS: 'Users',
      NEW_USER: 'New User',
      CONFIRM_DELETE_MSG: 'Are you sure do you want to delete this User?',
      USER_TABLE: {
        NAME: 'Name',
        EMAIL: 'Email',
        ROLES: 'Roles',
        STORES: 'Stores',
        ACTIONS: 'Actions',
      },
      VIEW_USERS: {
        USER_DETAIL: 'User Detail',
        NAME: 'Name',
        EMAIL: 'Email',
        ROLE_NAME: 'Role name',
        MODULE_WISE_ROLE_PERMISSION: 'Module Wise Role Permision',
        ADD: 'Add',
        EDIT: 'Edit',
        VIEW: 'View',
        DELETE: 'Delete',
      },
      ADD_USER: 'Add User',
      EDIT_USER: 'Edit User',
      DELETE_USER: 'Delete User',
      ADD_EDIT: {
        NAME: 'Name',
        EMAIL: 'Email',
        ROLE: 'Role',
        STORE: 'Store',
        SELECT_ROLE: 'Select Role',
        SELECT_STORE: 'Select Store',
        PIN: 'Pin',
        PIN_INVALID: 'PIN must be between 4 to 6 digits.',
      }
    },
    USER_ROLE_MANAGEMENT: {
      USER_ROLES: 'User Roles',
      ADD_USER_ROLE: 'Add User Role',
      CONFIRM_DELETE_MSG: 'Are you sure do you want to delete this User Role?',
      ROLE_TABLE: {
        NAME_IN_ENGLISH: 'Name in English',
        NAME_IN_SPANISH: 'Name in Spanish',
        DESCRIPTION: 'Description',
        BACKOFFICE_ACCESS: 'Back Office Access',
        ACTIONS: 'Actions',
      },
      DELETE_USER_ROLE: 'Delete User Role',
      ADD_ROLE: 'Add Role',
      EDIT_ROLE: 'Edit Role',
      ADD_EDIT: {
        NAME_IN_ENGLISH: 'Name in English',
        NAME_IN_SPANISH: 'Name in Spanish',
        DESCRIPTION: 'Description',
        CAN_ACCESS_BACKOFFICE: 'Can access Back Office',
        SELECT_ALL_PERMISSION: 'Select All Permissions',
        MODULE_WISE_ROLE_PERMISSION: 'Module Wise Role Permision',
        ADD: 'Add',
        EDIT: 'Edit',
        VIEW: 'View',
        DELETE: 'Delete',
      }
    },
    DEVICE_MANAGEMENT: {
      DEVICES: 'Devices',
      SEARCH_DEVICES: 'Search Devices',
      CONFIRM_DELETE_MSG: 'Are you sure do you want to delete this Device?',
      DEVICE_TABLE: {
        NAME: 'Name',
        STATUS: 'Status',
        BATTERY: 'Battery',
        LOCATION: 'Location',
        LAST_UPDATE: 'Last Update',
        ACTIONS: 'Actions',
      },
      ADD_EDIT: {
        NAME: 'Name',
        BATTERY: 'Battery',
        STATUS: 'Status',
        LOCATION: 'Location',
        SELECT_LOCATION: 'Select Location',
      },
      SELECT_STATUS: 'Select Status',
      ACTIVE: 'Active',
      INACTIVE: 'InActive',
      SORT_BY: 'Sort By',
      ASC: 'Asc',
      DESC: 'Desc',
      ADD_DEVICE: 'Add Device',
      EDIT_DEVICE: 'Edit Device',
      DELETE_DEVICE: 'Delete Device',
    },
    COUPON_MANAGEMENT: {
      COUPONS: 'Coupons',
      CONFIRM_DELETE_MSG: 'Are you sure do you want to delete this Coupon?',
      COUPON_TABLE: {
        TITLE: 'Title',
        CODE: 'Code',
        AMOUNT_PERCENT: 'Amount Or Percent Amount',
        COUPON_TYPE: 'Coupon Type',
        NUMBER_OF_USED: 'Number Of used',
        STATUS: 'Status',
        ACTIONS: 'Actions',
      },
      ADD_EDIT: {
        TITLE: 'Title',
        CODE: 'Code',
        AMOUNT_PERCENT: 'Amount Or Percent Amount',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        NUMBER_OF_USE: 'Number Of use',
        TYPE_OF_AMOUNT: 'Type of Amount',
        AMOUNT: 'Amount',
        PLEASE_SELECT_BRANCH_LOCATION: 'Please select branch location from header',
      },
      SELECT_TYPE: 'Select Type',
      FIXED_AMOUNT: 'Fixed Amount',
      PERCENTAGE_AMOUNT: 'Percentage Amount',
      SELECT_COUPON_TYPE: 'Select Coupon Type',
      COUPON: 'Coupon',
      GIFT_CARD: 'Gift Card',
      FILTER_BY: 'Filter By',
      ALL: 'All',
      UTILIZED: 'Utilized',
      SELECT_STATUS: 'Select Status',
      ENABLE: 'Enable',
      DISABLE: 'Disable',
      ADD_COUPON: 'Add Coupon',
      EDIT_COUPON: 'Edit Coupon',
      DELETE_COUPON: 'Delete Coupon',
    },
    ROLE_PERMISSION_GROUP: {
      ROLE_PERMISSION_GROUPS: 'Role Permission Group',
      SELECT_PERMISSION_GROUP: 'Select Permission Group',
      EDIT_GROUP_ROLE: 'Edit Group Role',
      ADD_GROUP_ROLE: 'Add Group Role',
      CONFIRM_DELETE_MSG: 'Are you sure do you want to delete this Role Permission Group?',
      ROLE_TABLE: {
        NAME_IN_ENGLISH: 'Name in English',
        NAME_IN_SPANISH: 'Name in Spanish',
        DESCRIPTION: 'Description',
        ACTIONS: 'Actions',
      },
      ADD_EDIT: {
        NAME_IN_ENGLISH: 'Name in English',
        NAME_IN_SPANISH: 'Name in Spanish',
        DESCRIPTION: 'Description',
        SELECT_ALL_PERMISSION: 'Select All Permissions',
        MODULE_WISE_ROLE_PERMISSION: 'Module Wise Role Permision',
        ADD: 'Add',
        EDIT: 'Edit',
        VIEW: 'View',
        DELETE: 'Delete',
      }
    },
    MY_SUBSCRIPTIONS: {
      MY_SUBSCRIPTIONS: 'My Subscriptions',
      CURRENT_PLAN: 'Current Plan',
      MY_SUBSCRIPTION_TABLE: {
        PLAN_NAME: 'Plan Name',
        PRICE: 'Price',
        DATE: 'Date',
        TRANSACTION_ID: 'Transaction ID',
        AMOUNT: 'Amount',
        PURCHASE_TYPE: 'Purchase Type',
        STATUS: 'Status',
        ACTION: 'Action',
        INVOICE: 'Invoice',
      },
      DETAIL: {
        NAME: 'Name',
        EMAIL: 'Email',
        STATUS: 'Status',
        PLAN_NAME: 'Plan Name',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        AMOUNT: 'Amount',
        BILLING_CYCLE: 'Billing Cycle',
      },
    },
    STATUS: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
    },
    PAYMENT_CYCLE: {
      MONTHLY: 'Monthly',
      YEARLY: 'Yearly',
    },
    PERMISSON_MENU: {
      home: "Home",
      generate_order: "Generate Order",
      order_status: "Order Status",
      order_history: "Order History",
      online_ordering: "Online Ordering",
      manage_category: "Manage Category",
      manage_groups: "Manage Groups",
      manage_items: "Manage Items",
      manage_modifiers: "Manage Modifiers",
      vendor_list: "Vendor List",
      vendor_purchase_orders: "Vendor Purchase Orders",
      vendor_payments: "Vendor Payments",
      shift_management: "Shift Management",
      my_shift: "My Shift",
      inventory_management: "Inventory Management",
      pos_management: "POS Management",
      manage_seating_areas: "Manage Seating Areas",
      manage_reservation: "Manage Reservation",
      table_management: "Table Management",
      waiting_list_management: "Waiting List Management",
      billing: "Billing",
      store_management: "Store Management",
      kds_management: "Kitchen Display System Management",
      kitchen_display_system: "Kitchen Display System",
      display_settings: "Display Settings",
      general_settings: "General Settings",
      tax_management: "Tax Management",
      profile_setting: "Profile Setting",
      order_receipt_setting: "Order Receipt Setting",
      image_library: "Image Library",
      manage_notification_preference: "Manage Notification Preference",
      transactions: "Transactions",
      walkthrough: "Walkthrough"
    }
  },

};
